import React, {FC, useCallback, useState} from 'react';

import {RendererOf} from '../../../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {BulkActionTypesEnum} from '../../../../../../helpers/bulkActionHelpers';
import {BulkActionConfirmationDialog} from './bulkActionConfirmationDialog';

/*
 * Props.
 */

interface BulkActionCoordinatorProps {
  onNormalAction: () => void;
  onBulkAction: () => void;
  shouldPerformBulkAction: boolean;
  actionType: BulkActionTypesEnum;
  children: RendererOf<() => void>;
}

/*
 * Component.
 */

export const BulkActionCoordinator: FC<BulkActionCoordinatorProps> = (props) => {
  const {shouldPerformBulkAction, onNormalAction} = props;
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const onAction = useCallback(() => {
    if (!shouldPerformBulkAction) {
      // Call the normal action and we're done.
      onNormalAction();
      return;
    }

    // Otherwise, show the bulk action confirmation.
    setIsConfirmationOpen(true);
  }, [shouldPerformBulkAction, onNormalAction, setIsConfirmationOpen]);

  return (
    <>
      {props.children(onAction)}
      {maybeRenderDialog(props, isConfirmationOpen, setIsConfirmationOpen)}
    </>
  );
};

/*
 * Helpers.
 */

function maybeRenderDialog(
  props: BulkActionCoordinatorProps,
  isConfirmationOpen: boolean,
  setIsConfirmationOpen: (arg: boolean) => void,
) {
  if (!isConfirmationOpen) {
    return null;
  }

  return (
    <BulkActionConfirmationDialog
      onConfirmClick={() => {
        setIsConfirmationOpen(false);
        props.onBulkAction();
      }}
      onRequestClose={() => setIsConfirmationOpen(false)}
      actionType={props.actionType}
    />
  );
}
